import VideoListingContentComponent from "./VideoListingContentComponent";

const VideoListingPopular =()=>{


    return (<>
        <VideoListingContentComponent
                tabKey={'popular'}
                showMostPopular={true}
                showMostLiked={false}
                showMyVideos={false}
                showAllVideos={false}
            /></>)
}
export default VideoListingPopular;